/**
 * A wrapper around Object.assign to enforce that the object can only be updated with properties of the object's type
 */
export const updateObject = (object, ...updates) => {
    return Object.assign(object, ...updates);
};
//# sourceMappingURL=update-object.js.map